var swiper = new Swiper('.public_swiper.swiper-container', {
  loop: true,
  autoplay: true,
  speed: 2500,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev'
  },
  // 如果需要分页器
  pagination: {
    el: '.swiper-pagination'
  }
});



$(document).ready(function () {
  $('.rezend_box').eq(0).click();
})
$('.rezend_box').click(function () {
  var index = $(".rezend_box").index(this);
  if (!$(this).hasClass('activated_btn')) {
    $(this).siblings().removeClass('activated_btn');
    $(this).addClass('activated_btn');
  }
  $('.rezend_cs').each(function (e, i) {
    $('.rezend_cs').siblings().removeClass('activateds');
    $('.rezend_cs').eq(index).addClass('activateds');
  })
})


window.onload = function() {
  animationNumber(['ku001', 'ku002', 'ku003', 'ku004'])
      //animationNumber('monthsprice')
}

function animationNumber(elementarray, options) {
  options = Object.assign({}, options, {
      'allTime': 3000,
      'speed': 20
  })
  var allTime = options.allTime,
      speed = options.speed;
  if (elementarray instanceof Array) {
      var oneNumArray = [],
          elementidArray = [],
          countArray = [],
          valueOneArray = [];
      for (var i = 0; i < elementarray.length; i++) {
          var elementid = document.getElementById(elementarray[i]),
              valueN = elementid.getAttribute('data-value'),
              valueOne = 0;
          if (valueN instanceof Array) {
              valueOne = eval(valueN)[0]
          } else {
              valueOne = valueN
          }
          valueOneArray[i] = valueOne
          oneNumber = Math.floor(valueOne / (allTime / speed)) || 1;
          oneNumArray[i] = oneNumber
          elementidArray[i] = elementid
          countArray[i] = 0
      }
      var datetime = setInterval(function() {
          var countClear = 0
          for (var k = 0; k < elementidArray.length; k++) {
              countArray[k] += oneNumArray[k]
              if (countArray[k] >= valueOneArray[k]) {
                  countClear++
                  countArray[k] = valueOneArray[k]
              }
              elementidArray[k].innerText = countArray[k];
          }
          if (countClear >= 4) {
              clearInterval(datetime)
          }
      }, 30)
  }
  if (typeof elementarray === 'string') {
      var e = document.getElementById(elementarray),
          allNum = eval(e.getAttribute('data-value'))[0] ? eval(e.getAttribute('data-value'))[0] : 0,
          oneNumber = Math.floor(allNum / (allTime / speed)),
          count = 0;
      var datetime = setInterval(function() {
          count += oneNumber
          if (count >= allNum) {
              clearInterval(datetime);
              count = allNum
          }
          e.innerText = count;
      }, 30)
  }
}